module.exports = __webpack_public_path__ + "img/017-change.b93efb19.svg";